export default __webpack_public_path__ + "static/media/Fury of the Void.56479fc2.jpg";